import * as React from 'react';

export default function IconConnectWithApple({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        fill="#000"
        fillRule="evenodd"
        d="M10.457 2.554c.583-.676.976-1.617.869-2.554-.84.032-1.858.537-2.46 1.212-.542.6-1.014 1.557-.887 2.475.938.07 1.895-.456 2.478-1.133ZM12.559 8.5c.024 2.422 2.217 3.227 2.241 3.238-.018.056-.35 1.147-1.155 2.275-.697.975-1.419 1.945-2.557 1.966-1.118.02-1.478-.635-2.757-.635-1.278 0-1.678.614-2.736.655-1.098.039-1.936-1.054-2.637-2.026-1.435-1.986-2.531-5.613-1.06-8.06a4.117 4.117 0 0 1 3.458-2.006c1.078-.02 2.096.695 2.756.695.659 0 1.897-.86 3.197-.733.545.021 2.074.21 3.055 1.587-.08.047-1.824 1.02-1.805 3.044Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
